import ApiClient from './ApiClient';

// Cria a caixa RCS da conta (POST /api/v1/accounts/:id/rcs_inboxes).
class RcsInboxesAPI extends ApiClient {
  constructor() {
    super('rcs_inboxes', { accountScoped: true });
  }
}

export default new RcsInboxesAPI();
